import classNames from "classnames";

import { useStyles } from "./styles";

export const Block: FC<TProps> = ({ children, className, ...restProps }) => {
  const classes = useStyles();

  return (
    <div className={classNames(classes.block, className)} {...restProps}>
      {children}
    </div>
  );
};

export const HelpBlock: FC<TProps> = ({ children, className, ...restProps }) => {
  const classes = useStyles();

  return (
    <div className={classNames(classes.block, classes.helpBlock, className)} {...restProps}>
      {children}
    </div>
  );
};
